import { Orders_Orders_App_Companyfeatureflag } from '@/__generated__/graphql';
import { TypedDocumentNode, gql } from '@apollo/client';

export type FeatureFlagsType =
  | Array<Pick<Orders_Orders_App_Companyfeatureflag, 'enabled' | 'id' | 'name'>>
  | undefined;
export type GetAllFeatureFlagsQueryType = {
  orders_orders_app_companyfeatureflag: FeatureFlagsType;
  userFeatureFlags: FeatureFlagsType;
  companyFeatureFlags: FeatureFlagsType;
  countryFeatureFlags: FeatureFlagsType;
};

export type GetAllFeatureFlagsQueryVariables = {
  companyId: string;
  userId: string;
  country: string;
};

// get all feature flags for all features
export const getAllFeatureFlags = gql`
  query getFeatureFlags($companyId: String, $userId: String, $country: String) {
    orders_orders_app_companyfeatureflag(
      where: {
        _and: {
          flagable_type: { _is_null: true }
          flagable_id: { _is_null: true }
          enabled: { _eq: true }
        }
      }
    ) {
      id
      name
      enabled
    }
    userFeatureFlags: orders_orders_app_companyfeatureflag(
      where: {
        _and: { flagable_type: { _eq: "user" }, flagable_id: { _eq: $userId } }
      }
    ) {
      id
      name
      enabled
    }
    companyFeatureFlags: orders_orders_app_companyfeatureflag(
      where: {
        _and: {
          flagable_type: { _eq: "company" }
          flagable_id: { _eq: $companyId }
        }
      }
    ) {
      id
      name
      enabled
    }
    countryFeatureFlags: orders_orders_app_companyfeatureflag(
      where: {
        _and: {
          flagable_type: { _eq: "country" }
          flagable_id: { _eq: $country }
        }
      }
    ) {
      id
      name
      enabled
    }
  }
` as TypedDocumentNode<
  GetAllFeatureFlagsQueryType,
  GetAllFeatureFlagsQueryVariables
>;
